<div>
    <div class="flex items-center mb-1">
        <!-- <h2 mat-dialog-title class="text-lg font-bold mb-1"></h2> -->
        <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close style="cursor: pointer;"></mat-icon>
    </div>

    <mat-dialog-content class="modal-content">
        <div class="top-0">
            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceHistoric" matSort>
                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-center">Usuario</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-center">
                        {{historic?.username}}
                    </td>
                </ng-container>
      
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-center">Correo</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-center">
                        {{historic?.email}}
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistoric" class="bg-gray-100 dark:bg-gray-900"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistoric;" class="border-b"></tr>
            </table>
        </div>
    </mat-dialog-content>
</div>